module.exports = __webpack_public_path__ + "img/map.77cb307d.png";